import { render } from "./InstanceDetailSettings.vue?vue&type=template&id=22ee52d4&scoped=true&ts=true"
import script from "./InstanceDetailSettings.vue?vue&type=script&lang=ts"
export * from "./InstanceDetailSettings.vue?vue&type=script&lang=ts"

import "./InstanceDetailSettings.vue?vue&type=style&index=0&id=22ee52d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ee52d4"]])

export default __exports__